export default __webpack_public_path__ + "static/SuisseIntl-Regular-250fe4fcb2550f1889ea13615ce27f01.woff";